// Image utility functions

export const generateImageCode = (imageNumber: number): string => {
  const paddedNumber = String(imageNumber).padStart(5, '0');
  const year = new Date().getFullYear();
  return `IMG/${paddedNumber}/${year}`;
};

export const getNextImageNumber = (existingImages: any[]): number => {
  if (existingImages.length === 0) {
    return 1;
  }

  const lastImage = existingImages[existingImages.length - 1];
  const lastCode = lastImage.kodGambar || lastImage.kod;

  // Parse the number from IMG/XXXXX/YYYY format
  const lastNumber = parseInt(lastCode.split('/')[1]);
  return lastNumber + 1;
};

export const convertFileToBase64 = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result as string;
      resolve(result);
    };
    reader.onerror = reject;
  });
};

export const ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/webp'];
export const ALLOWED_VIDEO_TYPES = ['video/mp4', 'video/webm', 'video/quicktime'];
export const MAX_FILE_SIZE = 50 * 1024 * 1024; // 50MB
